export const GET_APPLIED_MENUS = 'GET_APPLIED_MENUS';
export const SET_APPLIED_MENUS = 'SET_APPLIED_MENUS';
export const GET_APPLIED_MENUS_ERROR = 'GET_APPLIED_MENUS_ERROR';
export const CLEAR_APPLIED_MENUS_ERROR = 'CLEAR_APPLIED_MENUS_ERROR';

export const DELETE_APPLIED_MENUS_FETCHING = 'DELETE_APPLIED_MENUS_FETCHING';
export const DELETE_APPLIED_MENUS_ERROR = 'DELETE_APPLIED_MENUS_ERROR';
export const SET_APPLIED_MENUS_DELETE_SUCCESSFUL =
  'SET_APPLIED_MENUS_DELETE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listappliedmenus/types.js